import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {Blog} from './_models'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api'
const API_URL = `${BASE_URL}/blog`
const CATEGORY_URL = `${BASE_URL}/category`

const createBlog = (blog: Blog): Promise<Blog | undefined> => {
  return axios.post(API_URL, blog)
}

const updateBlog = (blog: Blog): Promise<Blog | undefined> => {
  return axios.patch(`${API_URL}/${blog.id}`, blog)
}

const deleteBlog = (blogId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/${blogId}`)
}

// Categories
const getBlogCategories = async () => {
  const res = await axios.get(CATEGORY_URL, {params: {filter: JSON.stringify({type: 'blog'})}})
  const data = res.data.data
  return data?.entities || data
}

const createBlogCategory = async (category: any) => {
  const res = await axios.post(CATEGORY_URL, {...category, type: 'blog'})
  const data = res.data.data
  return data?.entities || data
}

const updateBlogCategory = async (id: ID, category: any) => {
  const res = await axios.put(`${CATEGORY_URL}/${id}`, category)
  const data = res.data.data
  return data?.entities || data
}

const deleteBlogCategory = async (id: ID) => {
  await axios.delete(`${CATEGORY_URL}/${id}`)
}

export {
  deleteBlog,
  createBlog,
  updateBlog,
  getBlogCategories,
  createBlogCategory,
  updateBlogCategory,
  deleteBlogCategory,
}
